export default __webpack_public_path__ + "static/media/attendance-glyph-16px.0730f822.svg";